/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by chenjia on 2017/4/5.
	 */
	var lazyload = __webpack_require__(10);
	var goTop = __webpack_require__(2);
	var headFoot = __webpack_require__(1);
	var price = __webpack_require__(20);
	var tapEvent = __webpack_require__(13);
	var webviewOpt = __webpack_require__(45);
	var specialChooseModule = __webpack_require__(46);
	
	webviewOpt.init({
	  "imageLink": "http://img10.360buyimg.com/cms/jfs/t9205/1/1962459531/3945/6d5c647a/59c21b7aN33292692.png"
	});
	
	specialChooseModule.init();
	price.fn.init();
	tapEvent.tapItem(true);
	tapEvent.tapSale();
	tapEvent.tapLink(true);
	lazyload.fn.init();
	goTop.fn.init();
	headFoot.loadHeadAndFooter();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var jdHeaderAndFooter = {
	        init: function init() {
	            var u = navigator.userAgent.toLowerCase();
	
	            // jdhapp 京东健康
	            if (u.indexOf("jdapp") != -1 || u.indexOf("jdjr") != -1 || u.indexOf("kepler") != -1 || u.indexOf("micromessenger") != -1 || u.indexOf("jdhapp") != -1 || u.indexOf("yhdapp") != -1 || u.indexOf("mxxqapp") != -1) {
	                return false;
	            }
	
	            var param = new Object();
	            var sid = $("#sid").val();
	            var title = $("#title").val();
	            var link = $("#link").val();
	            var mchb = new MCommonHeaderBottom();
	
	            if (null != sid && sid.length > 0) {
	                param.sid = sid;
	            }
	            if (null != title && title.length > 0) {
	                param.title = title;
	            }
	            if (null != link && link.length > 0) {
	                param.link = link;
	            }
	
	            //加载头部
	            // if(location.href.indexOf("jd.hk") > -1) {
	            //     var tpl = require("../../template/header");
	            //     var render = template.compile(tpl.tpl);
	            //     var html = render({});
	            //     $("#m_common_header").append(html);
	            // } else {
	            var headerArg = { hrederId: 'm_common_header', title: title, sid: sid, isShowShortCut: false, selectedShortCut: '4' };
	            mchb.header(headerArg);
	            // }
	            $(".header").css("border-top", "0");
	        }
	    };
	    exports.loadHeadAndFooter = jdHeaderAndFooter.init;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var goTop = {
	        f: [],
	        init: function init() {
	            var self = this;
	            self.render();
	            self.handleGoTop();
	
	            if (self.isScroll()) {
	                $("#goTop").removeClass("hide");
	            }
	        },
	        render: function render() {
	            var goTopDiv = $('<div id="goTop" class="hide"></div>');
	            $(".viewport").append(goTopDiv);
	        },
	        handleGoTop: function handleGoTop() {
	            var self = this;
	            $("#goTop").on("tap", function () {
	                document.body.scrollTop = 0;
	                $("#goTop").addClass("hide");
	            });
	            if (typeof jQuery != "undefined") {
	                jQuery.noConflict();
	            }
	            $("body").on("touchstart", function (e) {
	                self.f.startX = e.touches[0].clientX;
	                self.f.endX = e.touches[0].clientX;
	                self.f.prevX = self.f.startX;
	                self.f.prevY = e.touches[0].clientY;
	            }).on("touchend", function (e) {
	                setTimeout(function () {
	                    if (document.body.scrollTop <= 0) {
	                        $("#goTop").addClass("hide");
	                    } else {
	                        $("#goTop").removeClass("hide");
	                    }
	                }, 400);
	            }).on("touchcancel", function (e) {
	                setTimeout(function () {
	                    if (document.body.scrollTop <= 0) {
	                        $("#goTop").addClass("hide");
	                    } else {
	                        $("#goTop").removeClass("hide");
	                    }
	                }, 400);
	            });
	        },
	        isScroll: function isScroll() {
	            if (document.body.scrollTop > 0) {
	                return true;
	            } else {
	                return false;
	            }
	        }
	    };
	    exports.fn = goTop;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = {
	        debug: false,
	        lock: false,
	        scrollEnd: 0
	    };
	
	    Config.serviceInterface = {
	        getZyLoadMore: "//jdw.jd.hk/zy/getCateSkuData.do",
	        getSearchData: "//jdw.jd.hk/search/list.do",
	        getSelfAttr: "//jdw.jd.hk/search/getSelfAttrBySkuId.do",
	        getCateBranch: "//jdw.jd.hk/category/getCategoryDataById.do",
	        getPrice: "//pm.3.cn/prices/mgets",
	        getPcpPrice: "//pm.3.cn/prices/pcpmgets?",
	        getTime: "//jdw.jd.hk/getTime.do",
	        IndexScrollToLoadMore: "//jdw.jd.hk/getCategoryData.do",
	        getSeckillStock: "//jdw.jd.hk/getStockBySkuId.do",
	        getGoodsFromConfig: "//jdw.jd.hk/classbaby/getClassBabyDataById.do?",
	        searchGoodsByCat: "//jdw.jd.hk/search/list.do",
	        searchGoodsByCatJsonp: "//jdw.jd.hk/search/listForJsonp.do",
	        getTopManCate: "//jdw.jd.hk/recommend/getData.do",
	        getTopManItem: "//jdw.jd.hk/recommend/getSkuInfo.do",
	        getReadPv: "//jdw.jd.hk/recommend/getPv.do",
	        doGrunt: "//jdw.jd.hk/user/doGrant.do",
	        uploadImg: "//jdw.jd.hk/clearance/uploadWaterMarkImg.do",
	        getFlagImg: "//jdw.jd.hk/choose/getFlagImgBySkuIds.do",
	        getCommentNum: "//jdw.jd.hk/choose/getGoodCount.do",
	        getCategorySkus: "//jdw.jd.hk/chooseclz/getCategorySkus.do",
	        attentionItem: "//follow-soa.jd.com/rpc/product/follow",
	        unAttentionItem: "//follow-soa.jd.com/rpc/product/unfollow",
	        isAttentionItems: "//follow-soa.jd.com/rpc/product/batchIsFollow",
	        isLogin: "//jdw.jd.hk/lieshou/isLogin.do",
	        productFollow: "//jdw.jd.hk/choose/productFollow.do",
	        getComponentInfo: "//jicc-web.jd.com/api/component/getComponentInfo/m",
	        getComponentInfoWQ: "//jicc-web.jd.com/api/component/getComponentInfo/wq",
	        uploadImage: "//jicc-web.jd.com/api/component/uploadImage/m",
	        uploadImageWQ: "//jicc-web.jd.com/api/component/uploadImage/wq",
	        saveImage: "//jicc-web.jd.com/api/component/save/m",
	        saveImageWQ: "//jicc-web.jd.com/api/component/save/wq",
	        // checkUploadNameWQ: "//jdw.jd.hk/clearance/checkUploadName.do",
	        checkUploadNameWQ: "//global.m.jd.com/clearance/checkUploadName.do",
	        checkUploadName: "//global.m.jd.com/clearance/checkUploadName.do",
	        newCheckUploadNameWQ: "//jdw.jd.hk/clearance/checkUploadNameNew.do",
	        newCheckUploadName: "//global.m.jd.com/clearance/checkUploadNameNew.do"
	    };
	
	    Config.validators = {
	        idCard: {
	            regExp: /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
	            errorMsg: "请填写正确的18位身份证号码"
	        }
	    };
	
	    module.exports = Config;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var lazyload = {
	        init: function init(opt) {
	            var that = this;
	            var op = {
	                anim: true
	            };
	            $.extend(op, opt);
	            that.img.init(op);
	        },
	        img: {
	            init: function init(n) {
	
	                var that = this;
	
	                function inViewport(el) {
	                    var top = window.pageYOffset;
	                    var btm = window.pageYOffset + window.innerHeight;
	                    var elTop = $(el).offset().top;
	                    var elBtm = elTop + $(el).height() + 100;
	                    if (elBtm >= top && elTop <= btm) {
	                        return true;
	                    } else {
	                        return false;
	                    }
	                    // return elTop >= top && elTop <= btm
	                }
	
	                $(document).off('scroll').on('scroll', function () {
	                    $('img.lazy').each(function (index, node) {
	                        var $this = $(this);
	                        if (!$this.attr('dataimg')) {
	                            return;
	                        }
	                        if (!inViewport(this)) {
	                            return;
	                        }
	                        if ($this.parents(".tabCnt").hasClass("hide")) {
	                            return;
	                        }
	                        if ($this.parents(".floor").hasClass("hide")) {
	                            return;
	                        }
	                        act($this);
	                    });
	                }).trigger('scroll');
	
	                setTimeout(function () {
	                    $(document).trigger('scroll');
	                }, 300);
	
	                function act(_self) {
	                    if (_self.attr('loaded')) return;
	                    var img = new Image(),
	                        original = _self.attr('dataimg');
	                    img.onload = function () {
	                        _self.attr('src', original).removeClass('lazy');
	                        n.anim && _self.css({ opacity: .2 }).animate({ opacity: 1 }, 280);
	                    };
	                    original && (img.src = original);
	                    _self.attr('loaded', true);
	                }
	            }
	        }
	    };
	    exports.fn = lazyload;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tplModel = {
	        render: function render(data, tpl) {
	            var render = template.compile(tpl.tpl);
	            return render(data);
	        }
	    };
	    module.exports = tplModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var vs = __webpack_require__(14);
	    var linkParser = __webpack_require__(15);
	
	    var JDAPP = "jdapp",
	        JDJR = "jdjr",
	        BROWSER = "browser";
	
	    var tapEvent = {
	        ua: vs.ua,
	        tapItem: function tapItem(useLinkParser) {
	            var self = this;
	
	            self.handleTap(".tapItem", function (_this) {
	                if ($(_this).parents("#cj-itemsList").length > 0) {
	                    var url = location.href.split("#")[0];
	                    history.pushState({}, "", url + "#reload");
	                }
	
	                var skuid = $(_this).attr("skuid");
	                if (self.ua == JDAPP || self.ua == JDJR) {
	                    location.href = self.openApp(skuid);
	                } else if (self.ua == BROWSER) {
	                    var itemLink = vs.setVs(self.composit4MJd(skuid, "", ""));
	                    if (useLinkParser) {
	                        // 如果使用linkParser解析itemLink区分微信平台
	                        itemLink = linkParser.parse(itemLink);
	                    }
	                    location.href = itemLink;
	                }
	            });
	        },
	        tapSale: function tapSale() {
	            var self = this;
	
	            self.handleTap(".tapSale", function (_this) {
	                var href = $(_this).attr("data-href");
	
	                if (self.ua == JDAPP || self.ua == JDJR) {
	                    if (href.indexOf("sale.jd.hk/m") >= 0) {
	                        href = href.replace("sale.jd.hk/m", "sale.jd.hk/app");
	                    } else if (href.indexOf("sale.jd.com/m") >= 0) {
	                        href = href.replace("sale.jd.com/m", "sale.jd.com/app");
	                    }
	                } else if (self.ua == BROWSER) {
	                    if (href.indexOf("sale.jd.hk/app") >= 0) {
	                        href = href.replace("sale.jd.hk/app", "sale.jd.hk/m");
	                    } else if (href.indexOf("sale.jd.com/app") >= 0) {
	                        href = href.replace("sale.jd.com/app", "sale.jd.com/m");
	                    }
	                }
	
	                location.href = vs.setVs(href);
	            });
	        },
	        tapLink: function tapLink(useLinkParser) {
	            var self = this;
	
	            self.handleTap(".tapLink", function (_this) {
	                if (window.sessionStorage) {
	                    var scrollTop = $("body").scrollTop();
	                    sessionStorage.setItem("scrollTop", scrollTop);
	                }
	
	                // 激活分类京选对应的tabs
	                var $me = $(_this);
	                var $jxTabs = $me.closest('.jxTabs');
	                if ($me.hasClass('moreItem') && $jxTabs.length > 0) {
	                    var matchLink = "jdw.jd.hk/chooseclz/index.html";
	                    var link = $(_this).attr("data-href");
	                    if (link.indexOf(matchLink) !== -1) {
	                        location.href = '//' + matchLink + '?activeCateId=' + $jxTabs.find('.curr').attr('cateid');
	                        return;
	                    }
	                }
	
	                var link = vs.setVs($(_this).attr("data-href"));
	                if (useLinkParser) {
	                    // 如果使用linkParser解析link区分微信平台
	                    link = linkParser.parse(link);
	                }
	                location.href = link;
	            });
	        },
	        tapVender: function tapVender() {
	            var self = this;
	
	            self.handleTap(".tapVender", function (_this) {
	                var venderId = $(_this).data('venderId');
	                if (self.ua == JDAPP) {
	                    location.href = self.conposeVenderLink4App(venderId);
	                } else if (self.ua == BROWSER || self.ua == JDJR) {
	                    href = "//shop.m.jd.com/?shopId=" + venderId;
	                    location.href = vs.setVs(href);
	                }
	            });
	        },
	        handleTap: function handleTap(className, callback) {
	            var self = this;
	            window.canAutoScroll = true;
	            var f = [];
	            if (typeof jQuery != "undefined") {
	                jQuery.noConflict();
	            }
	
	            $(className).off("touchstart").on("touchstart", function (e) {
	                f.startX = e.touches[0].clientX;
	                f.endX = e.touches[0].clientX;
	                f.prevX = f.startX;
	                f.prevY = e.touches[0].clientY;
	                f.directionX = "";
	                f.directionY = "";
	            }).off("touchmove").on("touchmove", function (e) {
	                f.directionX = e.touches[0].clientX - f.prevX > 0 ? "right" : "left";
	                f.directionY = e.touches[0].clientY - f.prevY > 0 ? "bottom" : "top";
	            }).off("touchend").on("touchend", function (e) {
	                if (f.directionY != "top" && f.directionY != "bottom" && f.directionX != "right" && f.directionX != "left") {
	                    if ($.isFunction(callback)) {
	                        callback(this);
	                    }
	                }
	            });
	        },
	        composit4MJd: function composit4MJd(sku, actId, sid) {
	            var link = "//m.jd.com/product/";
	            link = link + sku + ".html?";
	            link = link + "resourceType=m_destination_page";
	            link = link + "&resourceValue=" + actId;
	            return link;
	        },
	        openApp: function openApp(sku) {
	            var link = 'openapp.jdMobile://virtual?params={"category":"jump","des":"productDetail","skuId":"';
	            link = link + sku;
	            link = link + '","sourceType":"m_destination_page","sourceValue":"","landPageId":""}';
	            return link;
	        },
	        conposeVenderLink4App: function conposeVenderLink4App(shopId) {
	            var link = 'openApp.jdMobile://virtual?params=';
	            link += '{"category":"jump","des":"jshopMain","shopId":"' + shopId;
	            link += '","sourceType":"","sourceValue":"", "landPageId":"jshop.cx.mobile"}';
	            return link;
	        },
	        closeWebView: function closeWebView() {
	            var ua = navigator.userAgent.toLowerCase();
	            if (ua.indexOf(JDAPP) != -1) {
	                //如果是京东app里面，根据客户端是android或者ios版本,关闭webview
	                if (/iphone|ipad|ipod/.test(ua)) {
	                    location.href = "objc:closeMPage";
	                } else if (/android/.test(ua)) {
	                    JdAndroid.finishWebActivity();
	                }
	            } else {
	                //否则哪儿跳过来的，跳回到哪儿去，没有来源就跳回首页
	                if (!document.referrer || document.referrer == "" || document.referrer == window.location.href) {
	                    // location.href = "//m.jd.hk"
	                    location.href = "//jdw.jd.hk";
	                } else {
	                    location.href = document.referrer;
	                }
	            }
	        }
	    };
	
	    module.exports = tapEvent;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var u = navigator.userAgent;
	    var ua = "browser";
	    var vs = "m";
	
	    if (u.indexOf("jdapp") != -1) {
	        ua = "jdapp";
	    } else if (u.indexOf("MicroMessenger") != -1) {
	        ua = "browser";
	        vs = "wx";
	    } else if (u.indexOf("iPad") != -1) {
	        ua = "browser";
	        vs = "pad";
	    } else if (u.indexOf("JDJR-App") != -1 || u.indexOf("kepler") != -1) {
	        ua = "jdjr";
	        vs = "jdjr";
	    } else {
	        ua = "browser";
	        vs = "m";
	    }
	
	    if (getVs() != "") {
	        vs = getVs();
	    }
	
	    function getVs() {
	        var vs = "";
	        var href = location.href;
	        if (href.indexOf("vs=") != -1) {
	            var hrefArray = href.split("vs=");
	            if (hrefArray.length > 1) {
	                var vsStr = hrefArray[1];
	                var reg = /^[a-z0-9A-Z]+/;
	                var r = vsStr.match(reg);
	
	                if (r != null) {
	                    vs = r;
	                }
	            }
	        }
	        return vs;
	    }
	
	    function setVs(str) {
	        var reg = /^\bvs=\b[a-z0-9A-Z]+/;
	        if (str.indexOf("jdw.jd.hk") != -1) {
	            if (str.indexOf("vs=") != -1) {
	                str = str.replace(reg, "vs=" + vs);
	            } else {
	                if (str.indexOf("?") != -1) {
	                    str = str + "&vs=" + vs;
	                } else {
	                    str = str + "?vs=" + vs;
	                }
	            }
	        }
	        return str;
	    }
	
	    module.exports.setVs = setVs;
	    exports.ua = ua;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	/*
	 * 根据是否是微信手Q平台，解析不同的商详链接和通天塔活动链接
	*/
	var linkParser = {
	  isWQ: function isWQ() {
	    var ua = navigator.userAgent.toLowerCase();
	    if (ua.indexOf("micromessenger") !== -1 || ua.indexOf("qq/") !== -1) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  getUrlParam: function getUrlParam(link, name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var linkArr = link.split('?');
	    if (linkArr.length > 1) {
	      var r = link.split('?')[1].match(reg);
	      if (r != null) return r[2];
	    }
	    return null;
	  },
	  parse: function parse(link) {
	    var me = this,
	        sku = null,
	        returnUrl = link;
	
	    if (me.isWQ()) {
	      // 微信
	      if (link.indexOf('//m.jd.com/product/') !== -1 || link.indexOf('//item.m.jd.com/') !== -1 || link.indexOf('//mitem.jd.hk') !== -1 || link.indexOf('//item.jd.hk') !== -1 || link.indexOf('//item.jd.com') !== -1) {
	        // 商详页
	        var skuId = me.getUrlParam(link, 'wareId');
	        if (!skuId) {
	          var linkArr = link.split('/');
	          skuId = linkArr[linkArr.length - 1].split('.')[0];
	        }
	        return '//wqitem.jd.com/item/view?sku=' + skuId;
	      }
	
	      if (link.indexOf('//pro.m.jd.com') !== -1) {
	        //通天塔活动页
	        return link.replace('/mall/', '/wq/');
	      }
	
	      return link;
	    } else {
	      // 非微信
	      return link;
	    }
	  }
	  // ,
	  // parseAreaLink: function($area){
	  //   var me=this;
	  //   var $links=$area.find('a');
	  //   $links.each(function(){
	  //     $link=$(this);
	  //     $link.attr('href',me.parse($link.attr('href')));
	  //   })
	  // }
	};
	
	module.exports = linkParser;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var priceModel = __webpack_require__(21);
	
	    var price = {
	        skuArry: [],
	        pageNum: 40,
	        timeNow: null,
	        init: function init(tag) {
	            var self = this;
	            tag = tag || "";
	
	            if ($("#priceQuerySwitch").val() == "ON") {
	                self.getPrice(tag);
	            }
	        },
	        unique: function unique(arr) {
	            var result = [],
	                hash = {};
	            for (var i = 0, elem; (elem = arr[i]) != null; i++) {
	                if (!hash[elem]) {
	                    result.push(elem);
	                    hash[elem] = true;
	                }
	            }
	            return result;
	        },
	        getPrice: function getPrice(tag) {
	            var self = this;
	            var skuList = "";
	            self.skuArry = [];
	            //所有的skuid
	            $("[skuid]").each(function () {
	                if (!$(this).hasClass("priceLoad")) {
	                    skuList = skuList + "," + $(this).attr("skuid");
	                }
	            });
	
	            skuList = skuList.substring(1, skuList.length);
	            skuList = skuList.split(",");
	
	            skuList = self.unique(skuList);
	
	            var num = Math.ceil(skuList.length / self.pageNum);
	
	            for (var i = 1; i <= num; i++) {
	                var skuids = "";
	                for (var j = (i - 1) * self.pageNum; j < i * self.pageNum; j++) {
	                    if (typeof skuList[j] != "undefined") {
	                        skuids = skuids + "," + skuList[j];
	                    } else {
	                        continue;
	                    }
	                }
	                skuids = skuids.substring(1, skuids.length);
	
	                if (skuids != "") {
	                    self.skuArry.push(skuids);
	                }
	            }
	
	            if (self.skuArry.length == 0) {
	                return false;
	            }
	            for (var i = 0; i < self.skuArry.length; i++) {
	                if (tag == "seckill") {
	                    self.ajaxSecKillPrice(self.skuArry[i]);
	                } else if (tag == "pcpPrice") {
	                    self.ajaxPcpPrice(self.skuArry[i]);
	                } else {
	                    self.ajaxPrice(self.skuArry[i]);
	                }
	            }
	        },
	        ajaxPrice: function ajaxPrice(skuids) {
	            var self = this;
	            var arg = {
	                "skuids": skuids,
	                "origin": 2,
	                "source": "globalbuy"
	            };
	            var skuArray = skuids.split(',');
	            var leftSkuArray = skuArray.slice();
	
	            priceModel.ajaxGetPrice(arg, function (data) {
	                var length = skuArray.length;
	                for (var i = 0; i < length; i++) {
	                    var element = skuArray[i];
	                    $.each(data, function () {
	                        /**
	                         ** this.id是调用接口返回的skuid
	                         ** element是页面上的skuid
	                         ** thisObj是根据页面上的skuid找到的节点
	                         **/
	                        var newPrice = priceModel.formatPrice(this.p);
	                        var oldPrice = priceModel.formatPrice(this.m);
	
	                        var samPrice = null;
	                        if (this.sp) {
	                            samPrice = priceModel.formatPrice(this.sp);
	                        }
	
	                        var thisObj = $("[skuid='" + element + "']");
	
	                        thisObj.addClass("priceLoad");
	
	                        if (element === this.id && newPrice != "-1" && oldPrice != "-1") {
	                            thisObj.find(".price span").text("¥" + newPrice);
	                            thisObj.find(".price del").text("¥" + oldPrice);
	
	                            var samDiv = thisObj.find(".sam");
	                            if (samDiv.length > 0 && samPrice !== null) {
	                                samDiv.html("\n                                    <div class=\"p-sam\">&yen;" + samPrice + "</div>\n                                    <i class=\"logo\"></i>\n                                ");
	                            }
	
	                            var discount = priceModel.getDiscount(newPrice, oldPrice);
	                            if (discount != "") {
	                                thisObj.find(".discount").text(discount + "折");
	                            } else {
	                                thisObj.find(".discount").remove();
	                            }
	                            var ind = leftSkuArray.indexOf(element);
	                            if (ind >= 0) {
	                                leftSkuArray.splice(ind, 1);
	                            }
	                            return;
	                        }
	                    });
	                }
	                ;
	
	                if (leftSkuArray.length > 0) {
	                    leftSkuArray.forEach(function (element, _index) {
	                        var thisObj = $("[skuid='" + element + "']");
	                        thisObj.find(".price span").text("暂无价格").css({
	                            "font-size": ".6rem"
	                        });
	                        thisObj.find(".discount").remove();
	                        if (thisObj.find("em")) {
	                            thisObj.find("em").remove();
	                        }
	                        return;
	                    });
	                }
	            });
	        },
	        ajaxSecKillPrice: function ajaxSecKillPrice(skuids) {
	            var self = this;
	            var arg = {
	                "skuids": skuids,
	                "origin": 2,
	                "source": "globalbuy"
	            };
	            var skuArray = skuids.split(',');
	            var leftSkuArray = skuArray.slice();
	
	            priceModel.ajaxGetPrice(arg, function (data) {
	                var skuArray = skuids.split(",");
	                var cbData = [];
	                var existedArray = [];
	                $(data).each(function () {
	                    cbData.push(this.id);
	                });
	
	                for (var i = 0; i < skuArray.length; i++) {
	                    var skuid = skuArray[i];
	                    if (existedArray.indexOf(skuid) > -1) {
	                        continue;
	                    }
	                    existedArray.push(skuid);
	
	                    var num = cbData.indexOf(skuid);
	
	                    if (num > -1) {
	                        var skuObj = $("dd[skuid='" + skuid + "']");
	
	                        var newPrice = priceModel.formatPrice(data[num].p);
	                        var oldPrice = priceModel.formatPrice(data[num].m);
	
	                        skuObj.each(function () {
	                            var _this = $(this);
	                            if (_this.parents(".tabCnt").attr("id") == "begining") {
	                                if (newPrice == "-1") {
	                                    _this.find(".price span").text("暂无价格").css({
	                                        "font-size": ".6rem"
	                                    });
	                                    _this.find(".discount").remove();
	                                    if (_this.find("em")) {
	                                        _this.find("em").remove();
	                                    }
	                                    return true;
	                                } else {
	                                    _this.find(".price span").text("¥" + newPrice);
	                                }
	                            } else {
	                                if (newPrice == "-1") {
	                                    _this.find(".price span").text("暂无价格").css({
	                                        "font-size": ".6rem"
	                                    });
	                                    _this.find(".discount").remove();
	                                    if (_this.find("em")) {
	                                        _this.find("em").remove();
	                                    }
	                                    return true;
	                                } else if (newPrice.length == 1) {
	                                    _this.find(".price span").text("¥?");
	                                } else {
	                                    _this.find(".price span").text("¥?" + newPrice.substring(1, newPrice.length));
	                                }
	                            }
	
	                            _this.find("del").text("¥" + oldPrice).before($("<em>参考价:</em>"));
	
	                            var discount = priceModel.getDiscount(newPrice, oldPrice);
	                            if (discount != "") {
	                                _this.find(".discount").text(discount + "折");
	                            } else {
	                                _this.find(".discount").remove();
	                            }
	                        });
	                    }
	                }
	            });
	        },
	        ajaxPcpPrice: function ajaxPcpPrice(skuids) {
	            var self = this;
	            var arg = {
	                "skuids": skuids,
	                "origin": 2,
	                "source": "globalbuy"
	            };
	            var skuArray = skuids.split(',');
	            var leftSkuArray = skuArray.slice();
	
	            priceModel.ajaxGetPcpPrice(arg, function (data) {
	                var length = skuArray.length;
	                for (var i = 0; i < length; i++) {
	                    var element = skuArray[i];
	                    $.each(data, function () {
	                        /**
	                         ** this.id是调用接口返回的skuid
	                         ** element是页面上的skuid
	                         ** thisObj是根据页面上的skuid找到的节点
	                         **/
	                        var newPrice = priceModel.formatPrice(this.p);
	                        var oldPrice = priceModel.formatPrice(this.m);
	                        var pcpPrice = priceModel.formatPrice(this.pcp);
	
	                        var cheaper = -1;
	
	                        //console.log('newPrice: ', newPrice, 'oldPrice:', oldPrice, 'pcpPrice:', pcpPrice);
	
	                        var thisObj = $("[skuid='" + element + "']");
	
	                        thisObj.addClass("priceLoad");
	
	                        if (element === this.id && newPrice != "-1" && oldPrice != "-1") {
	                            thisObj.find(".price span").text("¥" + newPrice);
	                            thisObj.find(".price del").text("¥" + oldPrice);
	
	                            var discount = priceModel.getDiscount(newPrice, oldPrice);
	                            if (discount != "") {
	                                thisObj.find(".discount").text(discount + "折");
	                            } else {
	                                thisObj.find(".discount").remove();
	                            }
	                            var ind = leftSkuArray.indexOf(element);
	                            if (ind >= 0) {
	                                leftSkuArray.splice(ind, 1);
	                            }
	
	                            if (pcpPrice > 0) {
	                                cheaper = pcpPrice - newPrice;
	                            }
	
	                            if (cheaper.toString().length > 2 && cheaper % 1 !== 0) {
	                                cheaper = parseInt(cheaper.toFixed(2));
	                            }
	                            if (cheaper > 0) {
	                                thisObj.find('.compare .num').html(cheaper);
	                                thisObj.find('.compare').removeClass('hide');
	                            }
	                            //设置背景颜色
	                            if ($('#background').val()) {
	                                thisObj.find('.compare').css('background-color', $('#background').val());
	                                thisObj.find(".price span").css('color', $('#background').val());
	                            }
	
	                            return;
	                        }
	                    });
	                }
	                ;
	
	                if (leftSkuArray.length > 0) {
	                    leftSkuArray.forEach(function (element, _index) {
	                        var thisObj = $("[skuid='" + element + "']");
	                        thisObj.find(".price span").text("暂无价格").css({
	                            "font-size": ".6rem"
	                        });
	                        if ($('#background').val()) {
	                            thisObj.find(".price span").css('color', $('#background').val());
	                        }
	                        thisObj.find(".discount").remove();
	                        if (thisObj.find("em")) {
	                            thisObj.find("em").remove();
	                        }
	                        return;
	                    });
	                }
	            });
	        }
	    };
	    exports.fn = price;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(4);
	    var priceModel = {
	        ajaxGetPrice: function ajaxGetPrice(data, _success, error) {
	            $.ajax({
	                url: Config.serviceInterface.getPrice,
	                data: data,
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success)) {
	                        _success(data);
	                    }
	                }
	            });
	        },
	        ajaxGetPcpPrice: function ajaxGetPcpPrice(data, _success2, error) {
	            $.ajax({
	                url: Config.serviceInterface.getPcpPrice,
	                data: data,
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success2)) {
	                        _success2(data);
	                    }
	                }
	            });
	        },
	        ajaxGetTime: function ajaxGetTime(data, _success3, error) {
	            $.ajax({
	                url: Config.serviceInterface.getTime,
	                data: {},
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success3)) {
	                        _success3(data);
	                    }
	                }
	            });
	        },
	        getDiscount: function getDiscount(newPrice, oldPrice) {
	            var newPrice = newPrice * 10000;
	            var oldPrice = oldPrice * 10000;
	            var result = newPrice / oldPrice;
	
	            var discount = Math.ceil(Math.floor(result * 1000) / 10) / 10;
	            if (discount > 9.9) {
	                discount = "";
	            } else if (discount < 0.1) {
	                discount = 0.1;
	            } else {
	                discount = discount.toFixed(1);
	                if (discount.substring(discount.length - 1, discount.length) == "0") {
	                    discount = discount.substring(0, discount.length - 2);
	                }
	            }
	
	            return discount;
	        },
	        formatPrice: function formatPrice(price) {
	            price = price || "";
	            var arr = price.split(".");
	            if (arr.length == 2) {
	                if (arr[1] == "00") {
	                    return arr[0];
	                } else if (arr[1] == "0000") {
	                    return arr[0];
	                } else if (arr[1].indexOf("0") == arr[1].length - 1) {
	                    return price.substring(0, price.length - 1);
	                } else {
	                    return price;
	                }
	            } else {
	                return price;
	            }
	        }
	    };
	    module.exports = priceModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var lazyload = __webpack_require__(10);
	    var tab = {
	        f: [],
	        //selfObj: 自定义对象，允许在参数中传一个自定义对象
	        tapEvent: function tapEvent(className, startFn, moveFn, endFn, selfObj) {
	            var self = this;
	            self.f.lastOffsetX = 0;
	
	            if (typeof jQuery != "undefined") {
	                jQuery.noConflict();
	            }
	
	            $(className).on("touchstart", function (e) {
	                if (selfObj) {
	                    self.f.lastOffsetX = selfObj.getWrapperTranslate('x');
	                }
	
	                if ($.isFunction(startFn)) {
	                    startFn(e, self);
	                } else {
	                    self.defaultCallback_start(e, self);
	                }
	            }).on("touchmove", function (e) {
	                if ($.isFunction(moveFn)) {
	                    moveFn(e, self);
	                } else {
	                    self.defaultCallback_move(e, self);
	                }
	            }).on("touchend", function (e) {
	                var _this = $(this);
	                if ($.isFunction(endFn)) {
	                    endFn(e, _this, self, selfObj);
	                } else {
	                    self.defaultCallback_end(e, _this, self, selfObj);
	                }
	            });
	        },
	        justTap: function justTap() {
	            var self = this;
	            self.tapEvent(".tabs ul li", "", "", self.normal_tab);
	        },
	        normal_tab: function normal_tab(e, _this, self) {
	            var self = self;
	
	            if (self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {} else {
	                _this.parent().children().removeClass("curr");
	                _this.addClass("curr");
	
	                var idx = _this.attr("tab-idx");
	                var tabCnts = _this.parent().parent().children(".tabCnt");
	                tabCnts.addClass("hide");
	
	                tabCnts.each(function () {
	                    if ($(this).attr("cnt-idx") == idx) {
	                        $(this).removeClass("hide");
	                        return false;
	                    }
	                });
	
	                lazyload.fn.init();
	            }
	        },
	        defaultCallback_start: function defaultCallback_start(e, self) {
	            var self = self;
	
	            self.f.startX = e.touches[0].clientX;
	            self.f.endX = e.touches[0].clientX;
	            self.f.prevX = self.f.startX;
	            self.f.prevY = e.touches[0].clientY;
	            self.f.directionX = "";
	            self.f.directionY = "";
	        },
	        defaultCallback_move: function defaultCallback_move(e, self) {
	            var self = self;
	
	            if (e.touches.length > 0) {
	                self.f.directionX = e.touches[0].clientX - self.f.prevX > 0 ? "right" : "left";
	                self.f.directionY = e.touches[0].clientY - self.f.prevY > 0 ? "bottom" : "top";
	            } else {
	                self.f.directionX = "";
	                self.f.directionY = "";
	            }
	        },
	        defaultCallback_end: function defaultCallback_end(e, _this, self, selfObj) {
	            var self = self;
	
	            if (self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {} else {
	                _this.parent().children().removeClass("curr");
	                _this.addClass("curr");
	
	                var idx = _this.attr("tab-idx");
	                var tabCnts = _this.parent().parent().parent().children(".tabCnt");
	                tabCnts.addClass("hide");
	
	                tabCnts.each(function () {
	                    if ($(this).attr("cnt-idx") == idx) {
	                        $(this).removeClass("hide");
	                        return false;
	                    }
	                });
	
	                self.setPosition(_this, self, selfObj);
	                lazyload.fn.init();
	            }
	        },
	        autoSelected: function autoSelected(_this, selfObj) {
	            var self = this;
	
	            _this.parent().children().removeClass("curr");
	            _this.addClass("curr");
	
	            var wrapper = _this.parent().parent();
	            var dlObj = wrapper.find("dl");
	            var ddObj = wrapper.find("dd");
	
	            var ddOffsetX = _this.offset().left - $("body").offset().left;
	            var middle = wrapper.width() / 2 - _this.width() / 2;
	
	            var totalLength = 0;
	            ddObj.each(function () {
	                var ddWidth = _this[0].style.width;
	                ddWidth = parseFloat(ddWidth.substring(0, ddWidth.length - 2));
	
	                totalLength = totalLength + ddWidth;
	            });
	
	            var offsetLength = totalLength - wrapper.width();
	
	            if (offsetLength <= 0) {
	                return false;
	            }
	
	            var lastOffsetX = self.f.lastOffsetX || 0;
	
	            var moveX = middle - ddOffsetX + lastOffsetX;
	
	            if (moveX < -offsetLength) {
	                moveX = -offsetLength;
	            } else if (moveX > 0) {
	                moveX = 0;
	            }
	
	            self.f.lastOffsetX = moveX;
	
	            dlObj.css({
	                "transition-duration": "300ms",
	                "-webkit-transition-duration": "300ms",
	                "-moz-transition-duration": "300ms",
	                "-o-transition-duration": "300ms"
	            });
	
	            selfObj.setWrapperTranslate(moveX);
	        },
	        setPosition: function setPosition(_this, self, selfObj) {
	            var wrapper = _this.parent().parent();
	            var dlObj = wrapper.find("dl");
	            var ddObj = wrapper.find("dd");
	
	            var ddOffsetX = _this.offset().left - $("body").offset().left;
	            var middle = wrapper.width() / 2 - _this.width() / 2;
	
	            var totalLength = 0;
	            ddObj.each(function () {
	                var ddWidth = _this[0].style.width;
	                ddWidth = parseFloat(ddWidth.substring(0, ddWidth.length - 2));
	
	                totalLength = totalLength + ddWidth;
	            });
	
	            var offsetLength = totalLength - wrapper.width();
	
	            if (offsetLength <= 0) {
	                return false;
	            }
	
	            var moveX = middle - ddOffsetX + self.f.lastOffsetX;
	
	            if (moveX < -offsetLength) {
	                moveX = -offsetLength;
	            } else if (moveX > 0) {
	                moveX = 0;
	            }
	
	            self.f.lastOffsetX = moveX;
	
	            dlObj.css({
	                "transition-duration": "300ms",
	                "-webkit-transition-duration": "300ms",
	                "-moz-transition-duration": "300ms",
	                "-o-transition-duration": "300ms"
	            });
	
	            selfObj.setWrapperTranslate(moveX);
	        }
	    };
	
	    module.exports = tab;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Created by chenjia on 2017/4/18.
	 */
	var webviewOpt = {
	    init: function init(opt) {
	        //只有在jdapp中才继续
	        if (!this.isApp()) {
	            return false;
	        }
	        var param = {
	            "imageLink": ""
	        };
	        var settings = $.extend(param, opt);
	
	        this.addTitleImg(settings.imageLink);
	    },
	    getOs: function getOs() {
	        var device = '';
	        var ua = navigator.userAgent.toLowerCase();
	        if (ua.indexOf('iphone') !== -1) {
	            device = 'iphone';
	        } else if (ua.indexOf('android') !== -1) {
	            device = 'android';
	        } else if (ua.indexOf('ipad') !== -1) {
	            device = 'ipad';
	        }
	        return device;
	    },
	    isApp: function isApp() {
	        var u = navigator.userAgent.toLowerCase();
	        return u.indexOf("jdapp") > -1;
	    },
	    addTitleImg: function addTitleImg(imageLink) {
	        var os = this.getOs();
	        var url = location.origin + location.pathname;
	        var jdapp = {};
	        var param = [];
	        param[0] = "京选全球 从全球为你京挑细选";
	        param[1] = "诚心推荐来自全世界的美好，不用费心挑选。品质保证，华东部分211送达，尽在京选全球。";
	        param[2] = location.href;
	        param[3] = "https://img14.360buyimg.com/cms/jfs/t8101/189/1983194185/8706/5a58e772/59c21bc2N5d890039.jpg?t=1506661022036";
	        if (os === 'iphone') {
	            location.href = "openapp.jdmobile://communication?params={\"action\":\"syncShareData\",\"title\":\"" + param[0] + "\",\"content\":\"" + param[1] + "\",\"shareUrl\":\"" + encodeURIComponent(param[2]) + "\",\"iconUrl\":\"" + encodeURIComponent(param[3]) + "\",\"incentiveBizType\":\"\",\"incentiveBizId\":\"\",\"isCallBack\":\"N\"}";
	            setTimeout(function () {
	                location.href = 'openapp.jdmobile://communication?params={' + '"action":"sh_showImgTitle",' + '"imageUrl":"' + imageLink + '"' + '}';
	            }, 500);
	        } else if (os === 'android') {
	            var options = { imageUrl: imageLink };
	            options.isShow = "Y";
	            setTimeout(function () {
	                AndroidNavi && AndroidNavi.setTitle(JSON.stringify(options));
	            }, 500);
	            shareHelper.setShareInfo(param[0], param[1], param[2], param[3]);
	        }
	    }
	};
	
	module.exports = webviewOpt;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by chenjia on 2017/4/5.
	 */
	var specialChooseModel = __webpack_require__(47);
	var tabModel = __webpack_require__(24);
	var tplModel = __webpack_require__(11);
	var price = __webpack_require__(20);
	var login = __webpack_require__(48);
	var tapEvent = __webpack_require__(13);
	var Config = __webpack_require__(4);
	
	var REQUEST_NUM = 20;
	var pageNum = 1;
	var isClze = 2;
	var isScrollEnd = false;
	
	function getUrlParam(name) {
	    // 获取URL参数
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var r = window.location.search.substr(1).match(reg);
	    if (r != null) return r[2];
	    return null;
	}
	
	var specialChooseModule = {
	    init: function init() {
	        this.getFlagImg();
	        this.getCommentNum();
	        this.addEvent();
	        this.initConcern();
	    },
	    addEvent: function addEvent() {
	        var self = this;
	        //最IN尖货swiper
	        var isLoop = true;
	        var noSwiping = false;
	        var pagination = '.swiper-pagination';
	
	        var itemNum = $("#recommendSwiper .block").length;
	        if (itemNum === 1) {
	            isLoop = false;
	            noSwiping = true;
	            pagination = false;
	        }
	        var recommendSwiper = new Swiper("#recommendSwiper", {
	            slidesPerView: 1.34,
	            loop: isLoop,
	            loopAdditionalSlides: 2,
	            pagination: pagination,
	            autoplay: 3000,
	            autoplayDisableOnInteraction: false,
	            noSwiping: noSwiping,
	            noSwipingClass: 'block'
	        });
	
	        //分类京选swiper
	        var rootFontSize = $("html").css("font-size");
	        rootFontSize = rootFontSize.substring(0, rootFontSize.length - 2);
	        var offset = rootFontSize * 0.5;
	
	        $(".classify-swiper").each(function (i) {
	            var swiperId = "#classifySwiper" + (i + 1);
	
	            var itemObj = $(swiperId + ".classify-swiper .item");
	            var slideCount = itemObj.length;
	
	            new Swiper(swiperId, {
	                slidesPerView: 3.55,
	                freeMode: true,
	                lazyLoading: true,
	                lazyLoadingInPrevNext: true,
	                lazyLoadingInPrevNextAmount: 5,
	                slidesOffsetBefore: offset,
	                slidesOffsetAfter: offset,
	                onTouchEnd: function onTouchEnd(swiper) {
	                    if ($(swiperId).find(".item-end").length > 0) {
	                        var url = $(swiperId).find(".item-end").attr("data-href");
	                        var itemWidth = swiper.slides[0].clientWidth;
	                        var pxMoveToOpenPage = slideCount * itemWidth + itemWidth / 2 - 18.75 * rootFontSize;
	                        if (swiper.getWrapperTranslate('x') * -1 >= pxMoveToOpenPage) {
	                            window.location.href = url;
	                        }
	                    }
	                }
	            });
	        });
	
	        //tab页swiper
	        var slideNum = $(".jxTabs").find("dd").length;
	        switch (slideNum) {
	            case 1:
	                slideNum = 1;
	                break;
	            case 2:
	                slideNum = 2;
	                break;
	            case 3:
	                slideNum = 3;
	                break;
	            case 4:
	                slideNum = 4;
	                break;
	            default:
	                slideNum = 4.4;
	        }
	
	        window.newSwiper = new Swiper(".tabBg", {
	            slidesPerView: slideNum,
	            spaceBetween: 0,
	            freeMode: true,
	            // initialSlide: initialSlide,
	            freeModeSticky: false,
	            slidesOffsetBefore: offset,
	            onInit: function onInit(swiper) {
	                self.addTabsEvent(swiper);
	                var activeCateId = getUrlParam('activeCateId');
	                if (activeCateId) {
	                    $(".jxTabs .tabBg .swiper-slide[cateId='" + activeCateId + "']").trigger('touchend');
	                }
	            }
	        });
	
	        //关注
	        tapEvent.handleTap(".moreChoose .right", function (_this) {
	            login.isLogin(function (data) {
	                if (data.isLogin == true) {
	                    var concernObj = $(_this).find(".concern");
	                    var skuid = $(_this).parents(".item").find(".left").attr("skuid");
	                    //已登录
	                    if (!concernObj.hasClass("selected")) {
	                        //关注
	                        self.attentionItem(skuid);
	                    } else if (concernObj.hasClass("selected")) {
	                        //取消关注
	                        self.unAttentionItem(skuid);
	                    }
	                } else if (data.isLogin == false) {
	                    //未登录
	                    var currUrl = location.href;
	                    var loginUrl = data.loginUrl;
	                    window.location.href = loginUrl + currUrl;
	                }
	            });
	        });
	    },
	    addTabsEvent: function addTabsEvent(swiper) {
	        var self = this;
	
	        tabModel.tapEvent(".jxTabs .tabBg dd", self.tapStart, "", self.defaultCallback_end, swiper);
	
	        var timeout = null;
	        $(window).on("scroll", function () {
	
	            var tabObj = $(".jxTabs");
	            //tab置顶
	            if (tabObj.find(".tabBg").length !== 0) {
	                var tabCntObj = tabObj.find(".tab-cnt");
	                if (tabCntObj.length === 0) {
	                    return false;
	                }
	                var tabHeight = tabObj.find(".tabBg").height();
	                var tabCntOffset = tabCntObj.offset().top - tabHeight;
	                var maxOffset = tabCntOffset + tabCntObj.height();
	
	                if ($("body").scrollTop() > tabCntOffset && $("body").scrollTop() < maxOffset) {
	                    tabObj.addClass("tab-fixed");
	                } else {
	                    tabObj.removeClass("tab-fixed");
	                }
	            }
	
	            //分类页滚动加载更多
	            if (tabObj.find(".list-over").length === 0 && tabObj.parent().hasClass("classifyChoose") && $(".classifyChoose .tab-cnt li").length >= REQUEST_NUM && !Config.lock && !isScrollEnd) {
	                var scrollToLoadHeight = $(document).height() - 400;
	                if ($(window).scrollTop() + $(window).height() >= scrollToLoadHeight && Config.lock === false) {
	                    $(".classifyChoose .tab-cnt").append("\n                        <div class=\"loading\">\n                            <i></i>\n                            <div class=txt>\u52A0\u8F7D\u4E2D</div>\n                        </div>\n                    ");
	
	                    pageNum++;
	                    isClze = 1;
	                    var moduleId = tabObj.find("dl .curr").attr("cateid");
	                    var sign = $("#sign").val();
	                    var index = parseInt(tabObj.find("dl .curr").index()) + 1;
	                    var args = {
	                        "moduleId": moduleId,
	                        "pageNum": pageNum,
	                        "isClze": isClze,
	                        "sign": sign
	                    };
	                    Config.lock = true;
	
	                    specialChooseModel.ajaxGetCategorySkus(args, function (data) {
	                        Config.lock = false;
	                        $(".classifyChoose .loading").remove();
	
	                        data.isClassifyPage = true;
	                        data.index = index;
	                        data.pageNum = pageNum - 1;
	                        data.moduleId = moduleId;
	                        if (data.skus) {
	                            renderItems(data);
	
	                            if (data.skus.length < REQUEST_NUM) {
	                                addNoMoreTips();
	                            }
	                        } else {
	                            addNoMoreTips();
	                        }
	                    }, function () {
	                        Config.lock = false;
	                    });
	                }
	            }
	        }).trigger("scroll");
	
	        function addNoMoreTips() {
	            isScrollEnd = true;
	            $(".classifyChoose .tab-cnt").append("\n                                <div class=\"noMore\">\n                                    <div class=txt>\u6CA1\u6709\u66F4\u591A\u4E86~</div>\n                                </div>\n                            ");
	        }
	    },
	    getFlagImg: function getFlagImg() {
	        var skuids = "";
	
	        $(".moreChoose .item").each(function () {
	            var skuid = $(this).attr("skuid");
	
	            skuids += skuid + ",";
	        });
	
	        if (skuids === "") {
	            return false;
	        }
	
	        skuids = skuids.substring(0, skuids.length - 1);
	
	        var args = {
	            "skuIds": skuids
	        };
	        specialChooseModel.ajaxGetFlagImg(args, function (data) {
	            for (var skuid in data) {
	                var imgUrl = data[skuid];
	                if (imgUrl && imgUrl !== null) {
	                    var item = $(".moreChoose").find("[skuid='" + skuid + "']");
	                    item.find(".conduct").addClass("hasFlag").append('<img src="' + imgUrl + '" class="countryFlag">');
	                }
	            }
	        });
	    },
	    getCommentNum: function getCommentNum() {
	        var items = $(".topSale .item");
	        if (items.length === 0) {
	            return false;
	        }
	
	        var skuids = "";
	        items.each(function () {
	            var skuid = $(this).attr("skuid");
	
	            skuids += skuid + ",";
	        });
	
	        skuids = skuids.substring(0, skuids.length - 1);
	        var args = {
	            "skuIds": skuids
	        };
	        specialChooseModel.ajaxGetCommentNum(args, function (data) {
	            for (var skuid in data) {
	                var num = data[skuid];
	                if (num !== "0") {
	                    var item = $(".topSale").find("[skuid='" + skuid + "']");
	                    item.find(".appraise").text("已获" + num + "好评");
	                }
	            }
	        });
	    },
	    tapStart: function tapStart(e, self) {
	        self.f.startX = e.touches[0].clientX;
	        self.f.endX = e.touches[0].clientX;
	        self.f.prevX = self.f.startX;
	        self.f.prevY = e.touches[0].clientY;
	        self.f.directionX = "";
	        self.f.directionY = "";
	    },
	    defaultCallback_end: function defaultCallback_end(e, _this, self, selfObj) {
	
	        if (self.f.directionY === "top" || self.f.directionY === "bottom" || self.f.directionX === "right" || self.f.directionX === "left") {} else {
	            if (Config.lock) {
	                return false;
	            }
	
	            isScrollEnd = false;
	
	            loadData(_this);
	            self.setPosition(_this, self, selfObj);
	
	            if ($(".jxTabs").parent().hasClass("classifyChoose")) {
	                setTimeout(function () {
	                    $(window).scrollTop(0);
	                }, 300);
	            }
	        }
	    },
	    initConcern: function initConcern() {
	        var self = this;
	        //初始化是否关注
	        login.isLogin(function (data) {
	            if (data.isLogin == true) {
	                //已登录
	                self.isAttention();
	            } else if (data.isLogin == false) {
	                //未登录
	            }
	        });
	    },
	    isAttention: function isAttention() {
	        var skuids = "";
	        $(".moreChoose .item").each(function () {
	            var skuid = $(this).find(".itemImg").attr("skuid");
	            skuids += skuid + ",";
	        });
	
	        skuids = skuids.substring(0, skuids.length - 1);
	
	        var args = {
	            "productIds": skuids,
	            "oper": "isFollow"
	        };
	
	        specialChooseModel.ajaxAttentionProduct(args, function (data) {
	            for (var skuid in data) {
	                var isAttention = data[skuid];
	                var itemObj = $(".moreChoose").find("[skuid='" + skuid + "']");
	                if (isAttention) {
	                    itemObj.find(".concern").addClass("selected");
	                } else {
	                    itemObj.find(".concern").removeClass("selected");
	                }
	            }
	        });
	    },
	    attentionItem: function attentionItem(skuid) {
	        var args = {
	            "productIds": skuid,
	            "oper": "follow"
	        };
	
	        specialChooseModel.ajaxAttentionProduct(args, function (data) {
	            if (data === true) {
	                $(".moreChoose").find("[skuid='" + skuid + "'] .concern").addClass("selected");
	            }
	        });
	    },
	    unAttentionItem: function unAttentionItem(skuid) {
	        var args = {
	            "productIds": skuid,
	            "oper": "unFollow"
	        };
	
	        specialChooseModel.ajaxAttentionProduct(args, function (data) {
	            if (data === true) {
	                $(".moreChoose").find("[skuid='" + skuid + "'] .concern").removeClass("selected");
	            }
	        });
	    }
	};
	
	var bannerTpl = "\n    <div class=\"banner\">\n        <img src=\"<%=bannerImg%>\" report-eventid=\"MGlobalJX_ClassBanner\" report-eventparam=\"<%=moduleId%>\" data-href=\"<%=bannerLink%>\" class=\"bg tapSale J_ping\" clstag=\"pageclick|keycount|jdworldwidemchooseclz|category_<%=index%>_banner\">\n    </div>\n";
	
	var itemWrapperTpl = "\n    <ul class=\"clearfix\">\n    </ul>\n    <% if(!isClassifyPage && moreText != \"\") { %>\n    <div class=\"moreWp\">\n        <div class=\"moreItem tapLink J_ping\" data-href=\"<%=moreLink%>\" clstag=\"pageclick|keycount|jdworldwidemchoose|cate_<%=index%>_more\" report-eventid=\"MGlobalJX_HomeClassMore\" report-eventparam=\"<%=moduleId%>\">\n            <div class=\"txt\"><%=moreText%></div>\n            <i class=\"before\"></i>\n            <i class=\"after\"></i>\n        </div>\n    </div>\n    <% } %>\n";
	
	var itemTpl = "\n    <% if(isClassifyPage == true) { %>\n        <% for(var i=0; i<skus.length; i++) {%>\n            <li skuid=\"<%=skus[i].sku%>\" class=\"tapItem J_ping\" report-eventlevel=\"4\" clstag=\"pageclick|keycount|jdworldwidemchooseclz|category_<%=index%>_<%=(pageNum*20+(i+1))%>\" report-eventid=\"MGlobalJX_HomeClassProduct\" report-eventparam=\"<%=moduleId%>_<%=(pageNum*20+(i+1))%>_<%=skus[i].sku%>\">\n                <img src=\"<%=skus[i].skuImg%>\" class=\"itemImg lazy\">\n                <span class=\"name\"><%=skus[i].skuName%></span>\n                <span class=\"price\">\n                    <span></span>\n                    <del></del>\n                </span>\n            </li>\n        <% } %>\n    <% } else { %>\n        <% if(skus.length % 2 == 1) { %>\n            <% for(var i=0; i<skus.length - 1; i++) {%>\n                <li skuid=\"<%=skus[i].sku%>\" class=\"tapItem J_ping\" report-eventlevel=\"4\" clstag=\"pageclick|keycount|jdworldwidemchoose|cate_<%=index%>_<%=i+1%>\" report-eventid=\"MGlobalJX_HomeClassProduct\" report-eventparam=\"<%=moduleId%>_<%=i+1%>_<%=skus[i].sku%>\">\n                    <img src=\"<%=skus[i].skuImg%>\" class=\"itemImg lazy\">\n                    <span class=\"name\"><%=skus[i].skuName%></span>\n                    <span class=\"price\">\n                        <span></span>\n                        <del></del>\n                    </span>\n                </li>\n            <% } %>\n        <% } else { %>\n            <% for(var i=0; i<skus.length; i++) {%>\n                <li skuid=\"<%=skus[i].sku%>\" class=\"tapItem J_ping\" report-eventlevel=\"4\" clstag=\"pageclick|keycount|jdworldwidemchoose|cate_<%=index%>_<%=i+1%>\" report-eventid=\"MGlobalJX_HomeClassProduct\" report-eventparam=\"<%=moduleId%>_<%=i+1%>_<%=skus[i].sku%>\">\n                    <img src=\"<%=skus[i].skuImg%>\" class=\"itemImg lazy\">\n                    <span class=\"name\"><%=skus[i].skuName%></span>\n                    <span class=\"price\">\n                        <span></span>\n                        <del></del>\n                    </span>\n                </li>\n            <% } %>\n        <% } %>\n    <% } %>\n";
	
	function loadData(_this) {
	    _this.parent().children().removeClass("curr");
	    _this.addClass("curr");
	
	    var moduleId = _this.attr("cateid");
	    pageNum = 1;
	    isClze = 2;
	    if ($(".jxTabs").parent().hasClass("classifyChoose")) {
	        isClze = 1;
	    }
	    var sign = $("#sign").val();
	    var args = {
	        "moduleId": moduleId,
	        "pageNum": pageNum,
	        "isClze": isClze,
	        "sign": sign
	    };
	    Config.lock = true;
	    specialChooseModel.ajaxGetCategorySkus(args, function (data) {
	        Config.lock = false;
	        $(".jxTabs .tab-cnt").html("");
	
	        var isClassifyPage = false;
	        var moreLink = "";
	        var moreText = "";
	        var index = parseInt(_this.index()) + 1;
	        if ($(".jxTabs").parent().hasClass("classifyChoose")) {
	            isClassifyPage = true;
	        } else {
	            if (data.more) {
	                moreLink = data.more.moreLink;
	                moreText = data.more.moreText;
	            }
	        }
	        data.index = index;
	        if (isClassifyPage && data.banner) {
	            data.banner.index = index;
	            data.banner.moduleId = moduleId;
	            renderBanner(data.banner);
	        }
	
	        if (data.skus) {
	            var wrapperData = {
	                "moreLink": moreLink,
	                "moreText": moreText,
	                "isClassifyPage": isClassifyPage,
	                "index": index,
	                "moduleId": moduleId
	            };
	
	            renderItemWrapper(wrapperData);
	            data.isClassifyPage = isClassifyPage;
	            data.pageNum = pageNum - 1;
	            data.moduleId = moduleId;
	            renderItems(data);
	        }
	    }, function () {
	        Config.lock = false;
	    });
	}
	
	function renderBanner(bannerData) {
	    var render = template.compile(bannerTpl);
	    var bannerHtml = render(renderData);
	    $(".jxTabs .tab-cnt").prepend(bannerHtml);
	}
	
	function renderItemWrapper(wrapperData) {
	    var render = template.compile(itemWrapperTpl);
	    var itemWrapperHtml = render(wrapperData);
	    $(".jxTabs .tab-cnt").append(itemWrapperHtml);
	}
	
	function renderItems(itemData) {
	    var render = template.compile(itemTpl);
	    if (itemData.skus) {
	        itemData.skus = sliceSkus(itemData.skus);
	    }
	    var itemHtml = render(itemData);
	    $(".jxTabs .tab-cnt ul").append(itemHtml);
	    price.fn.init();
	    tapEvent.tapItem();
	    tapEvent.tapSale();
	    tapEvent.tapLink();
	}
	
	function sliceSkus(skus) {
	    // 取page-size进行分页数据切割
	    var newSkus = [];
	    var $jxTabs = $('.jxTabs');
	
	    if ($jxTabs.length > 0 && $jxTabs.attr('page-size')) {
	        var pageSize = parseInt($jxTabs.attr('page-size'), 10);
	        var length = skus.length > pageSize ? pageSize : skus.length;
	        return skus.slice(0, length);
	    } else {
	        return skus;
	    }
	}
	
	module.exports = specialChooseModule;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by chenjia on 2017/4/8.
	 */
	var Config = __webpack_require__(4);
	
	var specialChooseModel = {
	    ajaxGetFlagImg: function ajaxGetFlagImg(data, _success, error) {
	        $.ajax({
	            url: Config.serviceInterface.getFlagImg,
	            data: data,
	            method: 'post',
	            dataType: 'json',
	            success: function success(data) {
	                if (data.success) {
	                    if ($.isFunction(_success)) {
	                        _success(data.data);
	                    }
	                } else {
	                    if ($.isFunction(error)) {
	                        error();
	                    }
	                }
	            }
	        });
	    },
	    ajaxGetCommentNum: function ajaxGetCommentNum(data, _success2, error) {
	        $.ajax({
	            url: Config.serviceInterface.getCommentNum,
	            data: data,
	            method: "post",
	            dataType: "json",
	            success: function success(data) {
	                if (data.success) {
	                    if ($.isFunction(_success2)) {
	                        _success2(data.data);
	                    }
	                } else {
	                    if ($.isFunction(error)) {
	                        error();
	                    }
	                }
	            }
	        });
	    },
	    ajaxGetCategorySkus: function ajaxGetCategorySkus(data, _success3, error) {
	        if (Config.debug) {
	            var mockData = {
	                "data": {
	                    "skus": [{
	                        "sales": 988,
	                        "skuName": "欧顿(OUDUN)手表 男士多功能时尚商务三眼日历运动腕表防水钢带皮带石英男表 3011黑圈黑钢带O",
	                        "sku": "234368",
	                        "skuImg": "http://img12.360buyimg.com/test/jfs/t34/212/485373045/48561/712c9e5b/58e78fdcN41c2c50e.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }, {
	                        "sales": 765,
	                        "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
	                        "sku": "267713",
	                        "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
	                    }],
	                    "banner": {
	                        "bannerLink": "https://sale.jd.com/m/act/4I85P6vlHbsXgm.html",
	                        "bannerImg": "../tmp/jingxuan6.jpg"
	                    }
	                },
	                "success": true,
	                "errorMsg": ""
	            };
	            _success3(mockData.data);
	        } else {
	            $.ajax({
	                url: Config.serviceInterface.getCategorySkus,
	                data: data,
	                method: "post",
	                dataType: "json",
	                success: function success(data) {
	                    if (data.success) {
	                        if ($.isFunction(_success3)) {
	                            _success3(data.data);
	                        }
	                    } else {
	                        if ($.isFunction(error)) {
	                            error();
	                        }
	                    }
	                }
	            });
	        }
	    },
	    ajaxAttentionProduct: function ajaxAttentionProduct(data, _success4, error) {
	        if (Config.debug) {
	            _success4(true);
	        } else {
	            $.ajax({
	                url: Config.serviceInterface.productFollow,
	                data: data,
	                method: "post",
	                dataType: "jsonp",
	                success: function success(data) {
	                    if (data.success) {
	                        if ($.isFunction(_success4)) {
	                            _success4(data.result);
	                        }
	                    } else {
	                        if ($.isFunction(error)) {
	                            error();
	                        }
	                    }
	                }
	            });
	        }
	    }
	};
	module.exports = specialChooseModel;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by chenjia on 2016/10/9.
	 */
	'use strict';
	
	var isLoginModel = __webpack_require__(49);
	
	var login = {
	    isLogin: function isLogin(callback) {
	        isLoginModel.isLogin("", function (data) {
	            if ($.isFunction(callback)) {
	                callback(data);
	            }
	        });
	    }
	};
	
	module.exports = login;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by chenjia on 2016/10/9.
	 */
	var Config = __webpack_require__(4);
	
	var isLogin = {
	    isLogin: function isLogin(data, _success, error) {
	        $.ajax({
	            url: Config.serviceInterface.isLogin,
	            method: 'get',
	            dataType: 'json',
	            success: function success(data) {
	                if (data) {
	                    if ($.isFunction(_success)) {
	                        _success(data);
	                    }
	                } else {
	                    if ($.isFunction(error)) {
	                        error();
	                    }
	                }
	            }
	        });
	    }
	};
	
	module.exports = isLogin;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// /js/specialChoose.js